import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonModule, formatDate} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faCircleExclamation,
  faCircleXmark,
  faEye,
  faFileExcel,
  faMagnifyingGlass,
  faMagnifyingGlassPlus,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getFileNameFromResponse, validateAllFormFields} from '../../common/utils';
import saveAs from 'file-saver';
import {LoadingService} from '../services/loading.service';
import {AuthService} from '../services/auth.service';
import {DatePickerModule} from 'primeng/datepicker';
import {GenericSearchComponent} from '../shared/search-suggestion/search-suggestion.component';
import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap, takeUntil} from 'rxjs/operators';
import {ImageViewerComponent} from '../shared/image-viewer/image-viewer.component';
import {displayCameraEsn} from '../shared/camera-display';
import {VehicleNumberCopyDirective} from '../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../shared/constants/pagination.constants';

interface Vehicle {
  match: boolean;
  vehicleNo: string;
  date: string;
  time: string;
  direction: string;
  vehicleImage: string;
}
interface VehicleData {
  is_match: boolean;
  vehicle_number: string;
  created_at: string;
  // time: string;
  direction: string;
  camera_esn?: string;
  camera_esn_display?: string;
  entry_camera_esn?: string;
  exit_camera_esn?: string;
  full_image_path: string;
  vehicle_image_url: string;
}
@Component({
    selector: 'app-track-vehicle',
    templateUrl: './track-vehicle.component.html',
    styleUrls: ['./track-vehicle.component.css'],
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, FormsModule, DatePickerModule, GenericSearchComponent,
        ImageViewerComponent, VehicleNumberCopyDirective
    ]
})
export class TrackVehicleComponent implements OnInit, OnDestroy{
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  vehicleNumber: string = '';
  // fromDate: string = new Date().toISOString().substring(0, 10);
  // toDate: string = new Date().toISOString().substring(0, 10);
  searchText: string = '';
  vehicles: Vehicle[] = [];
  recordsPerPage: number = 10;
  currentPage: number = 1;
  filteredVehicles: Vehicle[] = [];
  showTable: boolean = false;
  noRecords: boolean = false;
  selectedImages: { url: string; direction: string }[] = [];
  showModal: boolean = false;
  trackVehicleForm: FormGroup;
  vehicleData: VehicleData[] = [];
  nextPage: number | null = null;
  previousPage: number | null = null;
  totalRecords: number = 0;
  camera_esn = [];
  today: Date = new Date();
  rawData: any;

  searchQuery = '';
  suggestions: string[] = [];
  private searchSubject = new Subject<string>();
  private readonly destroy$ = new Subject<void>();
  vehicleNumberArray = [];

  @ViewChild('vehicleWrapper') vehicleWrapperRef!: ElementRef;
  


  constructor(private router: Router,
    library:FaIconLibrary,
    private apiService: ApiService,
    private authService: AuthService,
    private toastr: ToastrService,
    fb: FormBuilder,
    public loadingservice: LoadingService) {
    library.addIcons(faTrash, faFileExcel, faAngleRight, faAngleLeft, faEye, faCircleXmark, faCircleExclamation, faMagnifyingGlassPlus,
      faMagnifyingGlass
    )

    this.trackVehicleForm = fb.group({
        vehicleNo: ['', Validators.required],
        fromDate: [this.today, Validators.required],
        toDate:  [this.today, Validators.required],
        searchText: [''],
        exportExcel: ['']
    })
    this.camera_esn = this.authService.getCurrentUserInfo()['camera_esn']

    // this.getVehicleNumberDropdown();
  }
  ngOnInit(): void {
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(query => this.apiService.getTrackVehicleNumberSuggestions(query)),
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      this.suggestions = data.suggestions;

    });

  }
  onSearch(query: string) {
    this.searchSubject.next(query);
  }

  selectSuggestion(suggestion: string) {
    this.trackVehicleForm.get('vehicleNo')?.setValue(suggestion); // fill input
    this.suggestions = []; // hide dropdown
  }

  highlightMatch(suggestion: string) {
    const regex = new RegExp(`(${this.trackVehicleForm.get('vehicleNo')?.value})`, 'gi');
    return suggestion.replace(regex, '<span class="highlight">$1</span>');
  }

  get vehicleNo(){ 
    return this.trackVehicleForm.get('vehicleNo');
  }
  get fromDate(){
    return this.trackVehicleForm.get('fromDate');
  }
  get toDate(){
    return this.trackVehicleForm.get('toDate');
  }

  get totalPages(): number {
    let totalPage = Math.ceil(this.totalRecords / this.recordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
  }

  displayCameraEsn(record: VehicleData): string {
    return displayCameraEsn(record);
  }


  trackVehicle(page: number, pageSize: number) {
  
    // debugger;
    if (this.trackVehicleForm.valid) {
      // Handle form submission
      // this.loadingservice.setLoading('track-vehicle', true)
      // console.log('Form Submitted', this.trackVehicleForm.value);
      // let formdata = new FormData();
      // if ( this.trackVehicleForm.value.searchText){
      //   formdata.append('search_text', this.trackVehicleForm.value.searchText);
      // }
      // formdata.append('vehicle_number', this.trackVehicleForm.value.vehicleNo);
      // formdata.append('from_date', this.trackVehicleForm.value.fromDate);
      // formdata.append('to_date', this.trackVehicleForm.value.toDate);
      // let fromdate = this.trackVehicleForm.value.fromDate
      // let fordate = new Date(fromdate);
      // console.log(fordate, 'from');

      
      // console.log(typeof this.trackVehicleForm.value.fromDate);
      // let dateString2 = "06/16/2025";
      // let date2 = new Date(dateString2);
      // console.log(date2)
      this.rawData = {
        'vehicle_number': this.trackVehicleForm.value.vehicleNo,
        "from_date":  formatDate(this.trackVehicleForm.value.fromDate.toISOString(), 'yyyy-MM-dd', 'en-IN'),
        "to_date":   formatDate(this.trackVehicleForm.value.toDate.toISOString(), 'yyyy-MM-dd', 'en-IN'),
        'camera_esn': this.camera_esn

      }
      // if ( this.trackVehicleForm.value.searchText){
      //   this.rawData.search_text = this.trackVehicleForm.value.searchText;
      // }
       if (this.searchText) {
        this.rawData.search_text = this.searchText;
      }

      this.apiService.trackVehicle(page, pageSize, this.rawData).subscribe({
          next: (response:any) => {
            this.loadingservice.setLoading('track-vehicle', false)
            this.vehicleData = response['results'];
            this.nextPage = response['next']
            this.previousPage = response['previous']
            this.totalRecords = response['count']
            if (this.totalRecords !== 0){
              this.showTable = true;
              this.noRecords = false;
            }else if (this.trackVehicleForm.value.searchText){
              this.showTable = true;
              this.noRecords = false;
            }
            else{
              this.showTable = false;
              this.noRecords = true;

            }
            // this.toastr.success("Vehicle added successfully.");
            // this.router.navigate(['/vehicle']);
          },
          error: (err) => {
            this.loadingservice.setLoading('track-vehicle', false)
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!.", 'Error');
            }
          }
        });
    }else{
      validateAllFormFields(this.trackVehicleForm);
      }
  }
  searchVehicles(pageSize: number) {
    this.currentPage = 1;
    this.trackVehicle(this.currentPage, pageSize)

  }

  next() {
    if (this.nextPage){
      this.currentPage++;
      this.trackVehicle(this.currentPage, this.recordsPerPage)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.trackVehicle(this.currentPage, this.recordsPerPage)
      }
  }
  selectPageSize(){
    if(this.recordsPerPage){
      this.currentPage = 1;
      this.trackVehicle(this.currentPage, this.recordsPerPage)
    }
  }
  viewImage(imageUrl: string, direction: string): void {
     const formattedDirection =
    direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();
    this.selectedImages = [];
    if (imageUrl) {
      this.selectedImages.push({ url: imageUrl, direction: formattedDirection });
    }
    this.showModal = true;
  }

  closeModal = () => {
  this.showModal = false;
  };

  exportToExcel() {
    if (this.trackVehicleForm.valid) {
      // Handle form submission
      // console.log('Form Submitted', this.trackVehicleForm.value);
      // let formdata = new FormData();
      // if ( this.trackVehicleForm.value.searchText){
      //   formdata.append('search_text', this.trackVehicleForm.value.searchText);
      // }
      // this.trackVehicleForm.value.exportExcel = true
      // formdata.append('export_to_excel', this.trackVehicleForm.value.exportExcel);
      // formdata.append('vehicle_number', this.trackVehicleForm.value.vehicleNo);
      // formdata.append('from_date', this.trackVehicleForm.value.fromDate);
      // formdata.append('to_date', this.trackVehicleForm.value.toDate);


      let rawData = {
        'vehicle_number': this.trackVehicleForm.value.vehicleNo,
        'from_date': formatDate(this.trackVehicleForm.value.fromDate.toISOString(), 'yyyy-MM-dd', 'en-IN'),
        'to_date': formatDate(this.trackVehicleForm.value.toDate.toISOString(), 'yyyy-MM-dd', 'en-IN') ,
        'export_to_excel': true,
        'search_text': this.searchText,
        'camera_esn': this.camera_esn
    }

      this.apiService.exportTrackVehicle(rawData).subscribe({
          next: (response:any) => {
            const fileName = getFileNameFromResponse(response);
              if (response.body) {
                  saveAs(response.body, fileName);
              }
          },
          error: (err) =>{
            this.toastr.error(`${err}`)
          }
        });
  }else{
    validateAllFormFields(this.trackVehicleForm)
    }
  }

onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
  this.currentPage = 1;
  this.recordsPerPage = 10;
  this.previousPage = event.previousPage;
  this.nextPage = event.nextPage;
  this.searchText = event.searchText;
  this.vehicleData = event.results;
  this.totalRecords = event.totalRecords;
}
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  if (this.vehicleWrapperRef && !this.vehicleWrapperRef.nativeElement.contains(event.target)) {
    this.suggestions = [];
    
  };
}

ngOnDestroy(): void {
  this.destroy$.next();
  this.destroy$.complete();
}

}
